import { CallingService } from '../calling.service';

export class CentroController {
  constructor(private callingService: CallingService) {}

  login() {
    return this.callingService.loginCentroAgent();
  }

  relogin() {
    return this.callingService.reloginCentroAgent();
  }

  activate(payload: { browserControlWs?: boolean } = {}) {
    return this.callingService.activateCentroAgent(payload);
  }

  getSipStatus(browserSipRegistered = false, browserSipInCall = false, browserSipRinging = false) {
    return this.callingService.getCentroSipStatus(browserSipRegistered, browserSipInCall, browserSipRinging);
  }

  getAgentStatus() {
    return this.callingService.getCentroAgentStatus();
  }

  logout() {
    return this.callingService.logoutCentroAgent();
  }

  manualOutboundCall(postObj: { phoneNo: string }) {
    return this.callingService.centroManualCall(postObj);
  }

  dropCall() {
    return this.callingService.centroHangupCall({ skipAutoDispose: true });
  }

  getCallContext() {
    return this.callingService.centroGetCallContext();
  }

    disposeCall(payload: {
      disposition: string;
      remarks?: string;
      subDisposition?: string;
      recordId?: string;
      crmDataId?: string;
      crmLeadId?: string;
      phoneNo?: string;
      callType?: string;
    }) {
    return this.callingService.centroDisposeCall(payload);
  }

  muteCall() {
    return this.callingService.centroMuteCall();
  }

  holdCall() {
    return this.callingService.centroHoldCall();
  }

  unholdCall() {
    return this.callingService.centroUnholdCall();
  }

  pauseCall() {
    return this.callingService.centroPauseCall();
  }

  resumeCall() {
    return this.callingService.centroResumeCall();
  }

  toggleStartMode() {
    return this.callingService.centroManualModeStart();
  }

  toggleStopMode() {
    return this.callingService.centroManualModeStop();
  }

  getCampaignAgents(campaignId?: string, options?: { mode?: string }) {
    return this.callingService.getCentroCampaignAgents(campaignId, options);
  }

  transferCall(payload: {
    targetAgentId?: string;
    targetExtension?: string;
    targetPhone?: string;
    targetCampaign?: string;
    transferType?: string;
  }) {
    return this.callingService.centroTransferCall(payload);
  }

  conferenceCall(phoneNo: string) {
    return this.callingService.centroConferenceCall({ phoneNo });
  }

  mergeCall() {
    return this.callingService.centroMergeCall();
  }

  unmergeCall() {
    return this.callingService.centroUnmergeCall();
  }
}
